import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

const ADMIN_ROLES = ['admin', 'super_admin'];

export default function ProtectedRoute({ children, adminOnly = false, superAdminOnly = false }) {
  const { user } = useAuth();
  if (user === null) return <div className="p-10 text-center text-muted-foreground">Caricamento…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (superAdminOnly && user.role !== 'super_admin') return <Navigate to="/dashboard" replace />;
  if (adminOnly && !ADMIN_ROLES.includes(user.role)) return <Navigate to="/dashboard" replace />;
  return children;
}
